module.exports = __webpack_public_path__ + "media/images/help/submission-management-fail-crop-3a80e5e891765d5a7f1fc87008bfa932.png";